import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { Quill } from 'react-quill';

interface ModuleOptions {
  container: string;
  unit: string;
  maxCharacters: number;
}

const CounterModule = (quill: Quill, options: ModuleOptions) => {
  const container = document.querySelector(options.container) as HTMLElement;

  quill.on('text-change', () => {
    container.innerText = `${quill.getLength() - 1}`;
  });
};

const MaxLengthModule = (quill: Quill, options: ModuleOptions) => {
  quill.on('text-change', () => {
    const quillTextLength = quill.getLength();
    const { maxCharacters } = options;

    if (maxCharacters && maxCharacters < quillTextLength) {
      quill.deleteText(maxCharacters - 1, quillTextLength);
    }
  });
};

Quill.register({
  'modules/counter': CounterModule,
  'modules/maxlength': MaxLengthModule,
});

const CounterWrapper = styled.div`
  text-align: right;
  margin-top: 0.5rem;
`;

const Counter = styled.div`
  display: inline-block;
`;

interface Props {
  maxCharacters: number;
}

const CharacterCounterModule: FunctionComponent<Props> = ({ maxCharacters }: Props) => {
  return (
    <CounterWrapper>
      <Counter id="counter">0</Counter> / {`${maxCharacters - 1}`}
    </CounterWrapper>
  );
};

export default CharacterCounterModule;
